import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import axios from 'axios';
import Dashboard from './pages/Dashboard';
import DealDetails from './pages/DealDetails';
import Underwriter from './pages/Underwriter';
import SavedDeals from './pages/SavedDeals';
import { Toaster } from './components/ui/sonner';
import './App.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  useEffect(() => {
    const seedDeals = async () => {
      try {
        await axios.post(`${API}/deals/seed`);
      } catch (error) {
        console.error('Error seeding deals:', error);
      }
    };
    seedDeals();
  }, []);

  return (
    <div className="App">
      <div className="vice-grid"></div>
      <div className="vice-grain"></div>
      <div className="scanlines"></div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/deal/:id" element={<DealDetails />} />
          <Route path="/underwriter" element={<Underwriter />} />
          <Route path="/saved" element={<SavedDeals />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" />
    </div>
  );
}

export default App;